module.exports = __webpack_public_path__ + "static/media/deltaTrust.99b1b554.png";